import type { FC } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { links } from '~/links.js'
import { useProfileOnboardingCompletedGuard } from './model/hooks.js'

type Props = {
  initialSetupRequired: boolean
  enabledDate?: string
}

export const RequireIsOnboarded: FC<Props> = ({ enabledDate, initialSetupRequired }) => {
  const location = useLocation()
  const { data: unsatisfiedRequirementLink, isLoading } = useProfileOnboardingCompletedGuard({
    enabledDate,
    initialSetupRequired,
  })

  if (isLoading) {
    return null
  }

  const shouldRedirectToRequirement = unsatisfiedRequirementLink && location.pathname !== unsatisfiedRequirementLink

  return shouldRedirectToRequirement ? <Navigate to={unsatisfiedRequirementLink} /> : <Outlet />
}

export const RequireIsOnboarding: FC<Props> = ({ enabledDate, initialSetupRequired }) => {
  const location = useLocation()
  const { data: unsatisfiedRequirementLink, isLoading } = useProfileOnboardingCompletedGuard({
    enabledDate,
    initialSetupRequired,
  })

  if (isLoading) {
    return null
  }

  const shouldRedirectToRequirement = unsatisfiedRequirementLink && location.pathname !== unsatisfiedRequirementLink

  if (shouldRedirectToRequirement) {
    return <Navigate to={unsatisfiedRequirementLink} />
  }

  return unsatisfiedRequirementLink ? <Outlet /> : <Navigate to={links.dashboardLink()} state={{ referer: 'setup' }} />
}
